// extracted by mini-css-extract-plugin
module.exports = {"pdf":"Pdf_pdf___hvI9","pdf__pages":"Pdf_pdf__pages__lWTNW"};